import add from "./addProcessingRole";
import remove from "./removeProcessingRole";

export default {
  add,
  remove,
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingRole/index.js